
import React from 'react';
import { Play, Square, ArrowRight, X } from 'lucide-react';
import { AppNode } from '../../../types';

interface GenericSimulationFormProps {
  node: AppNode;
  onNext: (data?: any) => void;
  isEnd?: boolean;
  onExit?: () => void;
}

export const GenericSimulationForm: React.FC<GenericSimulationFormProps> = ({ node, onNext, isEnd, onExit }) => {
  return (
    <div className="flex flex-col h-full bg-white dark:bg-slate-900">
      <div className="flex-1 overflow-y-auto p-6 flex flex-col items-center justify-center text-center">
         {isEnd ? (
             <>
                <div className="w-16 h-16 bg-emerald-50 dark:bg-emerald-900/20 border border-emerald-100 dark:border-emerald-800 text-emerald-600 dark:text-emerald-400 rounded-full flex items-center justify-center mb-4 animate-pulse">
                   <Square size={24} fill="currentColor" />
                </div>
                <h4 className="text-lg font-bold text-slate-900 dark:text-white mb-2">Process Completed</h4>
                <p className="text-xs text-slate-500 max-w-xs">
                    Reached <strong>{node.data.label}</strong> successfully.
                </p>
             </>
         ) : (
             <>
               <div className="w-16 h-16 bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-full flex items-center justify-center mb-4 shadow-sm">
                   <Play size={24} className="text-slate-400 ml-1"/>
               </div>
               <p className="text-slate-900 dark:text-white font-bold text-sm mb-1">Automated Step</p>
               <p className="text-slate-500 text-xs max-w-xs">
                   Executing <strong>{node.data.label}</strong> automatically.
               </p>
             </>
         )}
      </div>

      <div className="p-4 border-t border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-950 flex flex-col gap-3">
         {isEnd ? (
             <>
                 {onExit && (
                    <button 
                        onClick={onExit}
                        className="w-full px-5 py-2.5 rounded-lg border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-300 hover:bg-white dark:hover:bg-slate-800 font-bold flex items-center justify-center gap-2 transition-all text-sm"
                    >
                        Exit Simulation
                    </button>
                 )}
                 <button 
                    onClick={() => onNext()}
                    className="w-full px-5 py-2.5 rounded-lg bg-teal-600 hover:bg-teal-700 text-white font-bold flex items-center justify-center gap-2 shadow-sm transition-all text-sm"
                 >
                    Check Pending Paths
                    <ArrowRight size={16} />
                 </button>
             </>
         ) : (
             <button 
                onClick={() => onNext()}
                className="w-full px-5 py-2.5 rounded-lg bg-teal-600 hover:bg-teal-700 text-white font-bold flex items-center justify-center gap-2 shadow-sm transition-all hover:translate-y-px text-sm"
             >
                Next Step
                <ArrowRight size={16} />
             </button>
         )}
      </div>
    </div>
  );
};
